// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  ApplicationGetBackgroundImageUrlData,
  ApplicationGetBackgroundImageUrlErrors,
  ApplicationGetBackgroundImageUrlResponses,
  ApplicationGetEndOfLifeStatusData,
  ApplicationGetEndOfLifeStatusResponses,
  ApplicationGetRecommendedAppVersionData,
  ApplicationGetRecommendedAppVersionErrors,
  ApplicationGetRecommendedAppVersionResponses,
  ApplicationPostAddApplicationData,
  ApplicationPostAddApplicationErrors,
  ApplicationPostAddApplicationResponses,
  ApplicationPutUpdateApplicationData,
  ApplicationPutUpdateApplicationErrors,
  ApplicationPutUpdateApplicationResponses,
  AssistanceGetAssistanceOptionsData,
  AssistanceGetAssistanceOptionsResponses,
  AssistanceSendAssistanceData,
  AssistanceSendAssistanceErrors,
  AssistanceSendAssistanceResponses,
  CampaignsGetActiveCampaignsAsyncData,
  CampaignsGetActiveCampaignsAsyncErrors,
  CampaignsGetActiveCampaignsAsyncResponses,
  CampaignsReserveCampaignAsyncData,
  CampaignsReserveCampaignAsyncErrors,
  CampaignsReserveCampaignAsyncResponses,
  ClientErrorPostErrorData,
  ClientErrorPostErrorResponses,
  CustomerCreateCustomerProfileData,
  CustomerCreateCustomerProfileErrors,
  CustomerCreateCustomerProfileResponses,
  CustomerCreateTemporaryCustomerProfileData,
  CustomerCreateTemporaryCustomerProfileErrors,
  CustomerCreateTemporaryCustomerProfileResponses,
  CustomerDeleteCustomerData,
  CustomerDeleteCustomerErrors,
  CustomerDeleteCustomerResponses,
  CustomerEditConsentData,
  CustomerEditConsentErrors,
  CustomerEditConsentResponses,
  CustomerEditConsentsData,
  CustomerEditConsentsErrors,
  CustomerEditConsentsResponses,
  CustomerEditProfileData,
  CustomerEditProfileErrors,
  CustomerEditProfileResponses,
  CustomerForgotPasswordData,
  CustomerForgotPasswordErrors,
  CustomerForgotPasswordResponses,
  CustomerGetAvailableConsentsData,
  CustomerGetAvailableConsentsResponses,
  CustomerGetConstentsData,
  CustomerGetConstentsErrors,
  CustomerGetConstentsResponses,
  CustomerGetProfileData,
  CustomerGetProfileErrors,
  CustomerGetProfileResponses,
  CustomerRefreshTokenData,
  CustomerRefreshTokenResponses,
  CustomerRenewBearerTokenData,
  CustomerRenewBearerTokenResponses,
  CustomerUpdatePasswordData,
  CustomerUpdatePasswordErrors,
  CustomerUpdatePasswordResponses,
  CustomerUpdateTempUserProfileData,
  CustomerUpdateTempUserProfileErrors,
  CustomerUpdateTempUserProfileResponses,
  CustomerVerifyAppCustomerCredentialsData,
  CustomerVerifyAppCustomerCredentialsErrors,
  CustomerVerifyAppCustomerCredentialsResponses,
  CustomerVerifyCustomerCredentialsData,
  CustomerVerifyCustomerCredentialsErrors,
  CustomerVerifyCustomerCredentialsResponses,
  DeviationGetAllData,
  DeviationGetAllResponses,
  DeviationGetCriticalData,
  DeviationGetCriticalResponses,
  DeviationPostDeviationData,
  DeviationPostDeviationErrors,
  DeviationPostDeviationResponses,
  DeviationPushTargetedDeviationNotificationData,
  DeviationPushTargetedDeviationNotificationResponses,
  EntitlementGetCustomerEntitlementsData,
  EntitlementGetCustomerEntitlementsErrors,
  EntitlementGetCustomerEntitlementsResponses,
  EntitlementRegisterDiscountAsyncData,
  EntitlementRegisterDiscountAsyncErrors,
  EntitlementRegisterDiscountAsyncResponses,
  ExternalCampaignActivateExternalCampaignData,
  ExternalCampaignActivateExternalCampaignErrors,
  ExternalCampaignActivateExternalCampaignResponses,
  HistoryGetDetailsData,
  HistoryGetDetailsErrors,
  HistoryGetDetailsResponses,
  HistoryGetTransactionHistoryData,
  HistoryGetTransactionHistoryErrors,
  HistoryGetTransactionHistoryOrderData,
  HistoryGetTransactionHistoryOrderErrors,
  HistoryGetTransactionHistoryOrderResponses,
  HistoryGetTransactionHistoryResponses,
  InfoGetData,
  InfoGetInfoMessageData,
  InfoGetInfoMessageResponses,
  InfoGetResponses,
  JourneyGetData,
  JourneyGetEarlierDeparturesForLegData,
  JourneyGetEarlierDeparturesForLegErrors,
  JourneyGetEarlierDeparturesForLegResponses,
  JourneyGetErrors,
  JourneyGetJourneyPlanData,
  JourneyGetJourneyPlanErrors,
  JourneyGetJourneyPlanResponses,
  JourneyGetLaterDeparturesForLegData,
  JourneyGetLaterDeparturesForLegErrors,
  JourneyGetLaterDeparturesForLegResponses,
  JourneyGetResponses,
  JourneyRebookData,
  JourneyRebookErrors,
  JourneyRebookResponses,
  JourneyReplaceLegInJourneyData,
  JourneyReplaceLegInJourneyErrors,
  JourneyReplaceLegInJourneyResponses,
  LocationGetGoAheadLocationsData,
  LocationGetGoAheadLocationsResponses,
  OfferGetPeriodTicketOffersData,
  OfferGetPeriodTicketOffersErrors,
  OfferGetPeriodTicketOffersResponses,
  PushNotificationGetPreviousPushMessagesData,
  PushNotificationGetPreviousPushMessagesResponses,
  PushNotificationRegisterForPushData,
  PushNotificationRegisterForPushResponses,
  PushNotificationTestSendData,
  PushNotificationTestSendResponses,
  PushNotificationUnregisterFromPushData,
  PushNotificationUnregisterFromPushResponses,
  RecurringPaymentAuthorizeRecurringPaymentData,
  RecurringPaymentAuthorizeRecurringPaymentResponses,
  RecurringPaymentCreateRecurringPaymentData,
  RecurringPaymentCreateRecurringPaymentResponses,
  RecurringPaymentDeleteRecurringPaymentData,
  RecurringPaymentDeleteRecurringPaymentResponses,
  RecurringPaymentGetRecurringPaymentsData,
  RecurringPaymentGetRecurringPaymentsResponses,
  RecurringPaymentUpdateRecurringPaymentData,
  RecurringPaymentUpdateRecurringPaymentResponses,
  SeatMapGetAvailableSeatsData,
  SeatMapGetAvailableSeatsErrors,
  SeatMapGetAvailableSeatsResponses,
  SeatMapGetImagesData,
  SeatMapGetImagesErrors,
  SeatReservationReserveSpecificSeatsData,
  SeatReservationReserveSpecificSeatsErrors,
  SeatReservationReserveSpecificSeatsResponses,
  SegmentSubscriptionGetSegmentSubscriptionsData,
  SegmentSubscriptionGetSegmentSubscriptionsResponses,
  SegmentSubscriptionSubscribeToSegmentData,
  SegmentSubscriptionSubscribeToSegmentErrors,
  SegmentSubscriptionSubscribeToSegmentResponses,
  SegmentSubscriptionUnsubscribeFromSegmentData,
  SegmentSubscriptionUnsubscribeFromSegmentErrors,
  SegmentSubscriptionUnsubscribeFromSegmentResponses,
  SegmentSubscriptionUpdateSegmentSubscriptionData,
  SegmentSubscriptionUpdateSegmentSubscriptionResponses,
  TicketAddConsentData,
  TicketAddConsentErrors,
  TicketAddConsentResponses,
  TicketCancellTicketData,
  TicketCancellTicketErrors,
  TicketCancellTicketResponses,
  TicketCancelPaymentTransactionData,
  TicketCancelPaymentTransactionErrors,
  TicketCancelPaymentTransactionResponses,
  TicketCaptureData,
  TicketCaptureErrors,
  TicketCaptureResponses,
  TicketChangeOptionsData,
  TicketChangeOptionsErrors,
  TicketChangeOptionsResponses,
  TicketDistributeData,
  TicketDistributeErrors,
  TicketDistributeOrdersData,
  TicketDistributeOrdersErrors,
  TicketDistributeOrdersResponses,
  TicketDistributeResponses,
  TicketGetPaymentTransactionStatusData,
  TicketGetPaymentTransactionStatusErrors,
  TicketGetPaymentTransactionStatusResponses,
  TicketGetQrCodesForOrderData,
  TicketGetQrCodesForOrderErrors,
  TicketGetQrCodesForOrderResponses,
  TicketPayData,
  TicketPayErrors,
  TicketPayResponses,
  TicketPickupData,
  TicketPickupErrors,
  TicketPickupOrderGroupsData,
  TicketPickupOrderGroupsErrors,
  TicketPickupOrderGroupsResponses,
  TicketPickupResponses,
  TicketRefundTicketData,
  TicketRefundTicketErrors,
  TicketRefundTicketResponses,
  TicketReserveData,
  TicketReserveErrors,
  TicketReserveResponses,
  TicketReviewOrderData,
  TicketReviewOrderErrors,
  TicketReviewOrderResponses,
  TicketSendPdfData,
  TicketSendPdfErrors,
  TicketSendPdfResponses,
  TicketSendPdfWithOutAuthData,
  TicketSendPdfWithOutAuthErrors,
  TicketSendPdfWithOutAuthResponses,
  TicketSendReceiptData,
  TicketSendReceiptErrors,
  TicketSendReceiptResponses,
  TicketSendSmsData,
  TicketSendSmsErrors,
  TicketSendSmsResponses,
  TrafficInfoGetTrafficInformationData,
  TrafficInfoGetTrafficInformationResponses,
  TrafficInfoPostTrafficInformationData,
  TrafficInfoPostTrafficInformationErrors,
  TrafficInfoPostTrafficInformationResponses,
  WebhookTriggerUpdateBackgroundImageUrlData,
  WebhookTriggerUpdateBackgroundImageUrlResponses,
  WebhookTriggerUpdateExternalOperatorData,
  WebhookTriggerUpdateExternalOperatorResponses,
  WebhookTriggerUpdateSummerPassData,
  WebhookTriggerUpdateSummerPassResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Register a new application.
 *
 * The application shall call this endpoint before any other requests are made.
 */
export const applicationPostAddApplication = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationPostAddApplicationData, ThrowOnError>,
): RequestResult<ApplicationPostAddApplicationResponses, ApplicationPostAddApplicationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ApplicationPostAddApplicationResponses,
    ApplicationPostAddApplicationErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Application',
    ...options,
  });

/**
 * Update information for an existing application.
 *
 * The application shall call this endpoint before any other requests are made after an update of the application or the OS.
 */
export const applicationPutUpdateApplication = <ThrowOnError extends boolean = false>(
  options: Options<ApplicationPutUpdateApplicationData, ThrowOnError>,
): RequestResult<ApplicationPutUpdateApplicationResponses, ApplicationPutUpdateApplicationErrors, ThrowOnError> =>
  (options.client ?? client).put<
    ApplicationPutUpdateApplicationResponses,
    ApplicationPutUpdateApplicationErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Application',
    ...options,
  });

export const applicationGetRecommendedAppVersion = <ThrowOnError extends boolean = false>(
  options?: Options<ApplicationGetRecommendedAppVersionData, ThrowOnError>,
): RequestResult<
  ApplicationGetRecommendedAppVersionResponses,
  ApplicationGetRecommendedAppVersionErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ApplicationGetRecommendedAppVersionResponses,
    ApplicationGetRecommendedAppVersionErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Application/recommended-version',
    ...options,
  });

export const applicationGetBackgroundImageUrl = <ThrowOnError extends boolean = false>(
  options?: Options<ApplicationGetBackgroundImageUrlData, ThrowOnError>,
): RequestResult<ApplicationGetBackgroundImageUrlResponses, ApplicationGetBackgroundImageUrlErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ApplicationGetBackgroundImageUrlResponses,
    ApplicationGetBackgroundImageUrlErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Application/background-img-url',
    ...options,
  });

export const applicationGetEndOfLifeStatus = <ThrowOnError extends boolean = false>(
  options?: Options<ApplicationGetEndOfLifeStatusData, ThrowOnError>,
): RequestResult<ApplicationGetEndOfLifeStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ApplicationGetEndOfLifeStatusResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Application/endoflife-status',
    ...options,
  });

/**
 * Get options for assistance.
 *
 * Returns assistance options to be used by clients.
 */
export const assistanceGetAssistanceOptions = <ThrowOnError extends boolean = false>(
  options?: Options<AssistanceGetAssistanceOptionsData, ThrowOnError>,
): RequestResult<AssistanceGetAssistanceOptionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AssistanceGetAssistanceOptionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Assistance/options',
    ...options,
  });

/**
 * Send assistace for customer to Bane Nord
 *
 * Returns assistance booking for the order.
 */
export const assistanceSendAssistance = <ThrowOnError extends boolean = false>(
  options?: Options<AssistanceSendAssistanceData, ThrowOnError>,
): RequestResult<AssistanceSendAssistanceResponses, AssistanceSendAssistanceErrors, ThrowOnError> =>
  (options?.client ?? client).post<AssistanceSendAssistanceResponses, AssistanceSendAssistanceErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Assistance/send',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Get active campaigns from sanity
 */
export const campaignsGetActiveCampaignsAsync = <ThrowOnError extends boolean = false>(
  options?: Options<CampaignsGetActiveCampaignsAsyncData, ThrowOnError>,
): RequestResult<CampaignsGetActiveCampaignsAsyncResponses, CampaignsGetActiveCampaignsAsyncErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    CampaignsGetActiveCampaignsAsyncResponses,
    CampaignsGetActiveCampaignsAsyncErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Campaigns/active',
    ...options,
  });

/**
 * Reserves a campaign on given date
 */
export const campaignsReserveCampaignAsync = <ThrowOnError extends boolean = false>(
  options: Options<CampaignsReserveCampaignAsyncData, ThrowOnError>,
): RequestResult<CampaignsReserveCampaignAsyncResponses, CampaignsReserveCampaignAsyncErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CampaignsReserveCampaignAsyncResponses,
    CampaignsReserveCampaignAsyncErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Campaigns/reserve',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const clientErrorPostError = <ThrowOnError extends boolean = false>(
  options?: Options<ClientErrorPostErrorData, ThrowOnError>,
): RequestResult<ClientErrorPostErrorResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ClientErrorPostErrorResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/ClientError',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Create temporary customer profile
 */
export const customerCreateTemporaryCustomerProfile = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerCreateTemporaryCustomerProfileData, ThrowOnError>,
): RequestResult<
  CustomerCreateTemporaryCustomerProfileResponses,
  CustomerCreateTemporaryCustomerProfileErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CustomerCreateTemporaryCustomerProfileResponses,
    CustomerCreateTemporaryCustomerProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/createtempprofile',
    ...options,
  });

/**
 * Renew auth token
 */
export const customerRenewBearerToken = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerRenewBearerTokenData, ThrowOnError>,
): RequestResult<CustomerRenewBearerTokenResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CustomerRenewBearerTokenResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/renew',
    ...options,
  });

/**
 * Get customer profile
 */
export const customerGetProfile = <ThrowOnError extends boolean = false>(
  options: Options<CustomerGetProfileData, ThrowOnError>,
): RequestResult<CustomerGetProfileResponses, CustomerGetProfileErrors, ThrowOnError> =>
  (options.client ?? client).get<CustomerGetProfileResponses, CustomerGetProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/get-profile',
    ...options,
  });

/**
 * Get available consents
 */
export const customerGetAvailableConsents = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerGetAvailableConsentsData, ThrowOnError>,
): RequestResult<CustomerGetAvailableConsentsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CustomerGetAvailableConsentsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/get-available-consents',
    ...options,
  });

/**
 * Get consents
 */
export const customerGetConstents = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerGetConstentsData, ThrowOnError>,
): RequestResult<CustomerGetConstentsResponses, CustomerGetConstentsErrors, ThrowOnError> =>
  (options?.client ?? client).get<CustomerGetConstentsResponses, CustomerGetConstentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/get-consents',
    ...options,
  });

/**
 * Create customer profile
 */
export const customerCreateCustomerProfile = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerCreateCustomerProfileData, ThrowOnError>,
): RequestResult<CustomerCreateCustomerProfileResponses, CustomerCreateCustomerProfileErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    CustomerCreateCustomerProfileResponses,
    CustomerCreateCustomerProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/create',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Login customer
 */
export const customerVerifyCustomerCredentials = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerVerifyCustomerCredentialsData, ThrowOnError>,
): RequestResult<CustomerVerifyCustomerCredentialsResponses, CustomerVerifyCustomerCredentialsErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    CustomerVerifyCustomerCredentialsResponses,
    CustomerVerifyCustomerCredentialsErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/login',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Login customer in App
 * Logged in AI as url https://app-ga-backend.azurewebsites.net/rest/Customer/login-app
 */
export const customerVerifyAppCustomerCredentials = <ThrowOnError extends boolean = false>(
  options: Options<CustomerVerifyAppCustomerCredentialsData, ThrowOnError>,
): RequestResult<
  CustomerVerifyAppCustomerCredentialsResponses,
  CustomerVerifyAppCustomerCredentialsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CustomerVerifyAppCustomerCredentialsResponses,
    CustomerVerifyAppCustomerCredentialsErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/login-app',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Refresh token
 */
export const customerRefreshToken = <ThrowOnError extends boolean = false>(
  options: Options<CustomerRefreshTokenData, ThrowOnError>,
): RequestResult<CustomerRefreshTokenResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CustomerRefreshTokenResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/refresh-token',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Update temporary customer profile
 */
export const customerUpdateTempUserProfile = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerUpdateTempUserProfileData, ThrowOnError>,
): RequestResult<CustomerUpdateTempUserProfileResponses, CustomerUpdateTempUserProfileErrors, ThrowOnError> =>
  (options?.client ?? client).put<
    CustomerUpdateTempUserProfileResponses,
    CustomerUpdateTempUserProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/updatetempprofile',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Update customer password
 */
export const customerUpdatePassword = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerUpdatePasswordData, ThrowOnError>,
): RequestResult<CustomerUpdatePasswordResponses, CustomerUpdatePasswordErrors, ThrowOnError> =>
  (options?.client ?? client).put<CustomerUpdatePasswordResponses, CustomerUpdatePasswordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/update',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Edit customer profile
 */
export const customerEditProfile = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerEditProfileData, ThrowOnError>,
): RequestResult<CustomerEditProfileResponses, CustomerEditProfileErrors, ThrowOnError> =>
  (options?.client ?? client).put<CustomerEditProfileResponses, CustomerEditProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/edit-profile',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Edit customer consents
 */
export const customerEditConsents = <ThrowOnError extends boolean = false>(
  options: Options<CustomerEditConsentsData, ThrowOnError>,
): RequestResult<CustomerEditConsentsResponses, CustomerEditConsentsErrors, ThrowOnError> =>
  (options.client ?? client).put<CustomerEditConsentsResponses, CustomerEditConsentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/edit-consents',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Edit a customer consent
 */
export const customerEditConsent = <ThrowOnError extends boolean = false>(
  options: Options<CustomerEditConsentData, ThrowOnError>,
): RequestResult<CustomerEditConsentResponses, CustomerEditConsentErrors, ThrowOnError> =>
  (options.client ?? client).put<CustomerEditConsentResponses, CustomerEditConsentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/edit-consent',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Reset customer password
 */
export const customerForgotPassword = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerForgotPasswordData, ThrowOnError>,
): RequestResult<CustomerForgotPasswordResponses, CustomerForgotPasswordErrors, ThrowOnError> =>
  (options?.client ?? client).post<CustomerForgotPasswordResponses, CustomerForgotPasswordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/forgot-password',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Delete customer
 */
export const customerDeleteCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<CustomerDeleteCustomerData, ThrowOnError>,
): RequestResult<CustomerDeleteCustomerResponses, CustomerDeleteCustomerErrors, ThrowOnError> =>
  (options?.client ?? client).delete<CustomerDeleteCustomerResponses, CustomerDeleteCustomerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Customer/delete',
    ...options,
  });

/**
 * Add Deviation, or update existing based on situationId,
 * listning for
 * https://app-ga-backend.azurewebsites.net/rest/deviation/deviation
 */
export const deviationPostDeviation = <ThrowOnError extends boolean = false>(
  options?: Options<DeviationPostDeviationData, ThrowOnError>,
): RequestResult<DeviationPostDeviationResponses, DeviationPostDeviationErrors, ThrowOnError> =>
  (options?.client ?? client).post<DeviationPostDeviationResponses, DeviationPostDeviationErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Deviation/deviation',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  });

/**
 * Get critical deviations that are currently active.
 */
export const deviationGetCritical = <ThrowOnError extends boolean = false>(
  options?: Options<DeviationGetCriticalData, ThrowOnError>,
): RequestResult<DeviationGetCriticalResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<DeviationGetCriticalResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Deviation/critical',
    ...options,
  });

export const deviationGetAll = <ThrowOnError extends boolean = false>(
  options?: Options<DeviationGetAllData, ThrowOnError>,
): RequestResult<DeviationGetAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<DeviationGetAllResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Deviation',
    ...options,
  });

/**
 * Trigger calls to notificationHub.SendByUsedId for updated deviations on customer subscribed lines.
 * Listner for https://app-ga-backend.azurewebsites.net/rest/Deviation/targeted
 */
export const deviationPushTargetedDeviationNotification = <ThrowOnError extends boolean = false>(
  options?: Options<DeviationPushTargetedDeviationNotificationData, ThrowOnError>,
): RequestResult<DeviationPushTargetedDeviationNotificationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DeviationPushTargetedDeviationNotificationResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Deviation/targeted',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Register a discount by given discount code
 */
export const entitlementRegisterDiscountAsync = <ThrowOnError extends boolean = false>(
  options?: Options<EntitlementRegisterDiscountAsyncData, ThrowOnError>,
): RequestResult<EntitlementRegisterDiscountAsyncResponses, EntitlementRegisterDiscountAsyncErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    EntitlementRegisterDiscountAsyncResponses,
    EntitlementRegisterDiscountAsyncErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Entitlement/discount/register',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const entitlementGetCustomerEntitlements = <ThrowOnError extends boolean = false>(
  options?: Options<EntitlementGetCustomerEntitlementsData, ThrowOnError>,
): RequestResult<EntitlementGetCustomerEntitlementsResponses, EntitlementGetCustomerEntitlementsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    EntitlementGetCustomerEntitlementsResponses,
    EntitlementGetCustomerEntitlementsErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Entitlement',
    ...options,
  });

/**
 * Activate campaign by linking it to an orderLineId
 */
export const externalCampaignActivateExternalCampaign = <ThrowOnError extends boolean = false>(
  options: Options<ExternalCampaignActivateExternalCampaignData, ThrowOnError>,
): RequestResult<
  ExternalCampaignActivateExternalCampaignResponses,
  ExternalCampaignActivateExternalCampaignErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExternalCampaignActivateExternalCampaignResponses,
    ExternalCampaignActivateExternalCampaignErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/ExternalCampaign/activate',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Retrieve the order history for a customer.
 *
 * Returns a list of orders customer has made. To do a detailed search of a specific order
 * save OrderId and ServiceJourneyRef and send into details/{orderId}/{serviceJourneyRef}.
 * To map passengers from details/ api, save the OrderLineId as it represents each leg trip for a specific passenger.
 */
export const historyGetTransactionHistory = <ThrowOnError extends boolean = false>(
  options?: Options<HistoryGetTransactionHistoryData, ThrowOnError>,
): RequestResult<HistoryGetTransactionHistoryResponses, HistoryGetTransactionHistoryErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    HistoryGetTransactionHistoryResponses,
    HistoryGetTransactionHistoryErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/History/history',
    ...options,
  });

/**
 * Retrieve an order from history by id
 *
 * Returns a list of orders customer has made. To do a detailed search of a specific order
 * save OrderId and ServiceJourneyRef and send into details/{orderId}/{serviceJourneyRef}.
 * To map passengers from details/ api, save the OrderLineId as it represents each leg trip for a specific passenger.
 */
export const historyGetTransactionHistoryOrder = <ThrowOnError extends boolean = false>(
  options: Options<HistoryGetTransactionHistoryOrderData, ThrowOnError>,
): RequestResult<HistoryGetTransactionHistoryOrderResponses, HistoryGetTransactionHistoryOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<
    HistoryGetTransactionHistoryOrderResponses,
    HistoryGetTransactionHistoryOrderErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/History/historyOrder/{orderId}',
    ...options,
  });

export const historyGetDetails = <ThrowOnError extends boolean = false>(
  options: Options<HistoryGetDetailsData, ThrowOnError>,
): RequestResult<HistoryGetDetailsResponses, HistoryGetDetailsErrors, ThrowOnError> =>
  (options.client ?? client).get<HistoryGetDetailsResponses, HistoryGetDetailsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/History/details/{orderId}',
    ...options,
  });

export const infoGet = <ThrowOnError extends boolean = false>(
  options?: Options<InfoGetData, ThrowOnError>,
): RequestResult<InfoGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InfoGetResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Info',
    ...options,
  });

export const infoGetInfoMessage = <ThrowOnError extends boolean = false>(
  options?: Options<InfoGetInfoMessageData, ThrowOnError>,
): RequestResult<InfoGetInfoMessageResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InfoGetInfoMessageResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Info/infomessage',
    ...options,
  });

/**
 * Get all journeys with filter
 */
export const journeyGet = <ThrowOnError extends boolean = false>(
  options?: Options<JourneyGetData, ThrowOnError>,
): RequestResult<JourneyGetResponses, JourneyGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<JourneyGetResponses, JourneyGetErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Journey',
    ...options,
  });

/**
 * Gets journey plan without any offers.
 *
 * API returns the journey plan for a certain date time without any offers or products.
 */
export const journeyGetJourneyPlan = <ThrowOnError extends boolean = false>(
  options?: Options<JourneyGetJourneyPlanData, ThrowOnError>,
): RequestResult<JourneyGetJourneyPlanResponses, JourneyGetJourneyPlanErrors, ThrowOnError> =>
  (options?.client ?? client).get<JourneyGetJourneyPlanResponses, JourneyGetJourneyPlanErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Journey/journeyplan',
    ...options,
  });

/**
 * Get later departure alternatives for journey leg
 */
export const journeyGetLaterDeparturesForLeg = <ThrowOnError extends boolean = false>(
  options: Options<JourneyGetLaterDeparturesForLegData, ThrowOnError>,
): RequestResult<JourneyGetLaterDeparturesForLegResponses, JourneyGetLaterDeparturesForLegErrors, ThrowOnError> =>
  (options.client ?? client).get<
    JourneyGetLaterDeparturesForLegResponses,
    JourneyGetLaterDeparturesForLegErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Journey/journey/{tripPatternId}/legs/{legIndex}/later',
    ...options,
  });

/**
 * Get earlier departure alternatives for journey leg
 */
export const journeyGetEarlierDeparturesForLeg = <ThrowOnError extends boolean = false>(
  options: Options<JourneyGetEarlierDeparturesForLegData, ThrowOnError>,
): RequestResult<JourneyGetEarlierDeparturesForLegResponses, JourneyGetEarlierDeparturesForLegErrors, ThrowOnError> =>
  (options.client ?? client).get<
    JourneyGetEarlierDeparturesForLegResponses,
    JourneyGetEarlierDeparturesForLegErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Journey/journey/{tripPatternId}/legs/{legIndex}/earlier',
    ...options,
  });

/**
 * Replace part of journey
 */
export const journeyReplaceLegInJourney = <ThrowOnError extends boolean = false>(
  options: Options<JourneyReplaceLegInJourneyData, ThrowOnError>,
): RequestResult<JourneyReplaceLegInJourneyResponses, JourneyReplaceLegInJourneyErrors, ThrowOnError> =>
  (options.client ?? client).post<JourneyReplaceLegInJourneyResponses, JourneyReplaceLegInJourneyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Journey/journey/{tripPatternId}/legs/{legIndex}/replace/{replacingTripPatternId}',
    ...options,
  });

/**
 * Rebook part of journey
 */
export const journeyRebook = <ThrowOnError extends boolean = false>(
  options: Options<JourneyRebookData, ThrowOnError>,
): RequestResult<JourneyRebookResponses, JourneyRebookErrors, ThrowOnError> =>
  (options.client ?? client).get<JourneyRebookResponses, JourneyRebookErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Journey/Journey/rebook/{OrderId}/Orderline/{OrderlineId}',
    ...options,
  });

export const locationGetGoAheadLocations = <ThrowOnError extends boolean = false>(
  options?: Options<LocationGetGoAheadLocationsData, ThrowOnError>,
): RequestResult<LocationGetGoAheadLocationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<LocationGetGoAheadLocationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Location/locations',
    ...options,
  });

/**
 * Get period ticket offers
 */
export const offerGetPeriodTicketOffers = <ThrowOnError extends boolean = false>(
  options: Options<OfferGetPeriodTicketOffersData, ThrowOnError>,
): RequestResult<OfferGetPeriodTicketOffersResponses, OfferGetPeriodTicketOffersErrors, ThrowOnError> =>
  (options.client ?? client).post<OfferGetPeriodTicketOffersResponses, OfferGetPeriodTicketOffersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Offer/period-ticket',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const pushNotificationRegisterForPush = <ThrowOnError extends boolean = false>(
  options?: Options<PushNotificationRegisterForPushData, ThrowOnError>,
): RequestResult<PushNotificationRegisterForPushResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<PushNotificationRegisterForPushResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/PushNotification/register',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const pushNotificationUnregisterFromPush = <ThrowOnError extends boolean = false>(
  options?: Options<PushNotificationUnregisterFromPushData, ThrowOnError>,
): RequestResult<PushNotificationUnregisterFromPushResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<PushNotificationUnregisterFromPushResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/PushNotification/unregister',
    ...options,
  });

/**
 * Test route: Send push notification to users.
 */
export const pushNotificationTestSend = <ThrowOnError extends boolean = false>(
  options?: Options<PushNotificationTestSendData, ThrowOnError>,
): RequestResult<PushNotificationTestSendResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<PushNotificationTestSendResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/PushNotification/test/send',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const pushNotificationGetPreviousPushMessages = <ThrowOnError extends boolean = false>(
  options?: Options<PushNotificationGetPreviousPushMessagesData, ThrowOnError>,
): RequestResult<PushNotificationGetPreviousPushMessagesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<PushNotificationGetPreviousPushMessagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/PushNotification/history',
    ...options,
  });

/**
 * Returns the customer's recurring payments
 */
export const recurringPaymentGetRecurringPayments = <ThrowOnError extends boolean = false>(
  options?: Options<RecurringPaymentGetRecurringPaymentsData, ThrowOnError>,
): RequestResult<RecurringPaymentGetRecurringPaymentsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<RecurringPaymentGetRecurringPaymentsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/RecurringPayment/recurring-payments',
    ...options,
  });

/**
 * Creates a new recurring payment and returns Nets terminal
 */
export const recurringPaymentCreateRecurringPayment = <ThrowOnError extends boolean = false>(
  options?: Options<RecurringPaymentCreateRecurringPaymentData, ThrowOnError>,
): RequestResult<RecurringPaymentCreateRecurringPaymentResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<RecurringPaymentCreateRecurringPaymentResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/RecurringPayment/recurring-payments',
    ...options,
  });

/**
 * Deletes recurring payment
 */
export const recurringPaymentDeleteRecurringPayment = <ThrowOnError extends boolean = false>(
  options: Options<RecurringPaymentDeleteRecurringPaymentData, ThrowOnError>,
): RequestResult<RecurringPaymentDeleteRecurringPaymentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<RecurringPaymentDeleteRecurringPaymentResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/RecurringPayment/recurring-payments/{recurringPaymentId}',
    ...options,
  });

/**
 * Updates a recurring payment
 */
export const recurringPaymentUpdateRecurringPayment = <ThrowOnError extends boolean = false>(
  options: Options<RecurringPaymentUpdateRecurringPaymentData, ThrowOnError>,
): RequestResult<RecurringPaymentUpdateRecurringPaymentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<RecurringPaymentUpdateRecurringPaymentResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/RecurringPayment/recurring-payments/{recurringPaymentId}',
    ...options,
  });

/**
 * Authorizes recurring payment
 */
export const recurringPaymentAuthorizeRecurringPayment = <ThrowOnError extends boolean = false>(
  options: Options<RecurringPaymentAuthorizeRecurringPaymentData, ThrowOnError>,
): RequestResult<RecurringPaymentAuthorizeRecurringPaymentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<RecurringPaymentAuthorizeRecurringPaymentResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/RecurringPayment/recurring-payments/{recurringPaymentId}/authorize',
    ...options,
  });

/**
 * Get seatmap for order journey
 */
export const seatMapGetAvailableSeats = <ThrowOnError extends boolean = false>(
  options: Options<SeatMapGetAvailableSeatsData, ThrowOnError>,
): RequestResult<SeatMapGetAvailableSeatsResponses, SeatMapGetAvailableSeatsErrors, ThrowOnError> =>
  (options.client ?? client).get<SeatMapGetAvailableSeatsResponses, SeatMapGetAvailableSeatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SeatMap/available-seats/{orderId}',
    ...options,
  });

export const seatMapGetImages = <ThrowOnError extends boolean = false>(
  options: Options<SeatMapGetImagesData, ThrowOnError>,
): RequestResult<unknown, SeatMapGetImagesErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, SeatMapGetImagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SeatMap/resources/{path}',
    ...options,
  });

/**
 * Reserve seats for order
 */
export const seatReservationReserveSpecificSeats = <ThrowOnError extends boolean = false>(
  options: Options<SeatReservationReserveSpecificSeatsData, ThrowOnError>,
): RequestResult<
  SeatReservationReserveSpecificSeatsResponses,
  SeatReservationReserveSpecificSeatsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SeatReservationReserveSpecificSeatsResponses,
    SeatReservationReserveSpecificSeatsErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SeatReservation/specific-seats/{orderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const segmentSubscriptionGetSegmentSubscriptions = <ThrowOnError extends boolean = false>(
  options?: Options<SegmentSubscriptionGetSegmentSubscriptionsData, ThrowOnError>,
): RequestResult<SegmentSubscriptionGetSegmentSubscriptionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<SegmentSubscriptionGetSegmentSubscriptionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SegmentSubscription',
    ...options,
  });

export const segmentSubscriptionSubscribeToSegment = <ThrowOnError extends boolean = false>(
  options?: Options<SegmentSubscriptionSubscribeToSegmentData, ThrowOnError>,
): RequestResult<
  SegmentSubscriptionSubscribeToSegmentResponses,
  SegmentSubscriptionSubscribeToSegmentErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SegmentSubscriptionSubscribeToSegmentResponses,
    SegmentSubscriptionSubscribeToSegmentErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SegmentSubscription',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const segmentSubscriptionUnsubscribeFromSegment = <ThrowOnError extends boolean = false>(
  options: Options<SegmentSubscriptionUnsubscribeFromSegmentData, ThrowOnError>,
): RequestResult<
  SegmentSubscriptionUnsubscribeFromSegmentResponses,
  SegmentSubscriptionUnsubscribeFromSegmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    SegmentSubscriptionUnsubscribeFromSegmentResponses,
    SegmentSubscriptionUnsubscribeFromSegmentErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SegmentSubscription/{subscriptionId}',
    ...options,
  });

export const segmentSubscriptionUpdateSegmentSubscription = <ThrowOnError extends boolean = false>(
  options: Options<SegmentSubscriptionUpdateSegmentSubscriptionData, ThrowOnError>,
): RequestResult<SegmentSubscriptionUpdateSegmentSubscriptionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<SegmentSubscriptionUpdateSegmentSubscriptionResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/SegmentSubscription/{subscriptionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Add consent to the order.
 *
 * Adds a specific consent to the order.
 */
export const ticketAddConsent = <ThrowOnError extends boolean = false>(
  options: Options<TicketAddConsentData, ThrowOnError>,
): RequestResult<TicketAddConsentResponses, TicketAddConsentErrors, ThrowOnError> =>
  (options.client ?? client).put<TicketAddConsentResponses, TicketAddConsentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/consent/{orderId}',
    ...options,
  });

/**
 * Get payment transaction status.
 */
export const ticketGetPaymentTransactionStatus = <ThrowOnError extends boolean = false>(
  options: Options<TicketGetPaymentTransactionStatusData, ThrowOnError>,
): RequestResult<TicketGetPaymentTransactionStatusResponses, TicketGetPaymentTransactionStatusErrors, ThrowOnError> =>
  (options.client ?? client).get<
    TicketGetPaymentTransactionStatusResponses,
    TicketGetPaymentTransactionStatusErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/capture/payment/{paymentId}/transaction/{transactionId}',
    ...options,
  });

/**
 * Complete the payment.
 * NB Only called for Nets Card payments - Vipps have no capture step from backend.
 */
export const ticketCapture = <ThrowOnError extends boolean = false>(
  options: Options<TicketCaptureData, ThrowOnError>,
): RequestResult<TicketCaptureResponses, TicketCaptureErrors, ThrowOnError> =>
  (options.client ?? client).put<TicketCaptureResponses, TicketCaptureErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/capture/payment/{paymentId}/transaction/{transactionId}',
    ...options,
  });

/**
 * Cancel payment transaction.
 */
export const ticketCancelPaymentTransaction = <ThrowOnError extends boolean = false>(
  options: Options<TicketCancelPaymentTransactionData, ThrowOnError>,
): RequestResult<TicketCancelPaymentTransactionResponses, TicketCancelPaymentTransactionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    TicketCancelPaymentTransactionResponses,
    TicketCancelPaymentTransactionErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/capture/payment/{paymentId}/transaction/{transactionId}/cancel',
    ...options,
  });

/**
 * Distribute a paid ticket to NOD
 */
export const ticketDistribute = <ThrowOnError extends boolean = false>(
  options: Options<TicketDistributeData, ThrowOnError>,
): RequestResult<TicketDistributeResponses, TicketDistributeErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketDistributeResponses, TicketDistributeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/distribute/{orderId}',
    ...options,
  });

/**
 * Distribute paid tickets to NOD
 */
export const ticketDistributeOrders = <ThrowOnError extends boolean = false>(
  options: Options<TicketDistributeOrdersData, ThrowOnError>,
): RequestResult<TicketDistributeOrdersResponses, TicketDistributeOrdersErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketDistributeOrdersResponses, TicketDistributeOrdersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/distribute',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Get Qr codes and animations for order
 */
export const ticketGetQrCodesForOrder = <ThrowOnError extends boolean = false>(
  options: Options<TicketGetQrCodesForOrderData, ThrowOnError>,
): RequestResult<TicketGetQrCodesForOrderResponses, TicketGetQrCodesForOrderErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketGetQrCodesForOrderResponses, TicketGetQrCodesForOrderErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/qrCodes/{orderId}',
    ...options,
  });

/**
 * Pay for order
 *
 * If the order is canceled by the user while in the Nets webview, a retry can be made with this same API for the same order.
 */
export const ticketPay = <ThrowOnError extends boolean = false>(
  options: Options<TicketPayData, ThrowOnError>,
): RequestResult<TicketPayResponses, TicketPayErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketPayResponses, TicketPayErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/pay/{orderId}',
    ...options,
  });

export const ticketPickup = <ThrowOnError extends boolean = false>(
  options: Options<TicketPickupData, ThrowOnError>,
): RequestResult<TicketPickupResponses, TicketPickupErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketPickupResponses, TicketPickupErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/pickup/{orderGroupId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const ticketPickupOrderGroups = <ThrowOnError extends boolean = false>(
  options: Options<TicketPickupOrderGroupsData, ThrowOnError>,
): RequestResult<TicketPickupOrderGroupsResponses, TicketPickupOrderGroupsErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketPickupOrderGroupsResponses, TicketPickupOrderGroupsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/pickup',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const ticketRefundTicket = <ThrowOnError extends boolean = false>(
  options: Options<TicketRefundTicketData, ThrowOnError>,
): RequestResult<TicketRefundTicketResponses, TicketRefundTicketErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketRefundTicketResponses, TicketRefundTicketErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/refund/{orderId}',
    ...options,
  });

/**
 * Reserve an offer.
 *
 * clientType is an enum on back-end. Values are
 * Web (default)
 * Android
 * iOS
 * App
 */
export const ticketReserve = <ThrowOnError extends boolean = false>(
  options?: Options<TicketReserveData, ThrowOnError>,
): RequestResult<TicketReserveResponses, TicketReserveErrors, ThrowOnError> =>
  (options?.client ?? client).post<TicketReserveResponses, TicketReserveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/reserve',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

/**
 * Find available changes which are available to perform
 *
 * Gives a list of change options for an order. Change options are options which either comes with a fee which have to be paid for, or free.
 */
export const ticketChangeOptions = <ThrowOnError extends boolean = false>(
  options: Options<TicketChangeOptionsData, ThrowOnError>,
): RequestResult<TicketChangeOptionsResponses, TicketChangeOptionsErrors, ThrowOnError> =>
  (options.client ?? client).get<TicketChangeOptionsResponses, TicketChangeOptionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/ChangeOptions/{orderId}',
    ...options,
  });

/**
 * Review the specified order
 *
 * Returns all information about the order.
 */
export const ticketReviewOrder = <ThrowOnError extends boolean = false>(
  options: Options<TicketReviewOrderData, ThrowOnError>,
): RequestResult<TicketReviewOrderResponses, TicketReviewOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<TicketReviewOrderResponses, TicketReviewOrderErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/review/{orderId}',
    ...options,
  });

export const ticketSendPdf = <ThrowOnError extends boolean = false>(
  options: Options<TicketSendPdfData, ThrowOnError>,
): RequestResult<TicketSendPdfResponses, TicketSendPdfErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketSendPdfResponses, TicketSendPdfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/pdf/{orderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const ticketSendPdfWithOutAuth = <ThrowOnError extends boolean = false>(
  options: Options<TicketSendPdfWithOutAuthData, ThrowOnError>,
): RequestResult<TicketSendPdfWithOutAuthResponses, TicketSendPdfWithOutAuthErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketSendPdfWithOutAuthResponses, TicketSendPdfWithOutAuthErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/pdf-noauth/{orderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Logged in app insights as "POST Ticket/SendReceipt [orderId]"
 */
export const ticketSendReceipt = <ThrowOnError extends boolean = false>(
  options: Options<TicketSendReceiptData, ThrowOnError>,
): RequestResult<TicketSendReceiptResponses, TicketSendReceiptErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketSendReceiptResponses, TicketSendReceiptErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/receipt/{orderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * NB still in use by mobile apps?
 */
export const ticketSendSms = <ThrowOnError extends boolean = false>(
  options: Options<TicketSendSmsData, ThrowOnError>,
): RequestResult<TicketSendSmsResponses, TicketSendSmsErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketSendSmsResponses, TicketSendSmsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/sms/{orderId}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Cancel ticket for small children.
 */
export const ticketCancellTicket = <ThrowOnError extends boolean = false>(
  options: Options<TicketCancellTicketData, ThrowOnError>,
): RequestResult<TicketCancellTicketResponses, TicketCancellTicketErrors, ThrowOnError> =>
  (options.client ?? client).post<TicketCancellTicketResponses, TicketCancellTicketErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Ticket/cancell/orderid{orderId}/orderLineId/{orderLineId}',
    ...options,
  });

export const trafficInfoPostTrafficInformation = <ThrowOnError extends boolean = false>(
  options?: Options<TrafficInfoPostTrafficInformationData, ThrowOnError>,
): RequestResult<TrafficInfoPostTrafficInformationResponses, TrafficInfoPostTrafficInformationErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    TrafficInfoPostTrafficInformationResponses,
    TrafficInfoPostTrafficInformationErrors,
    ThrowOnError
  >({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/traffic-info',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const trafficInfoGetTrafficInformation = <ThrowOnError extends boolean = false>(
  options: Options<TrafficInfoGetTrafficInformationData, ThrowOnError>,
): RequestResult<TrafficInfoGetTrafficInformationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TrafficInfoGetTrafficInformationResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/traffic-info/{datedServiceJourneyId}',
    ...options,
  });

export const webhookTriggerUpdateBackgroundImageUrl = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookTriggerUpdateBackgroundImageUrlData, ThrowOnError>,
): RequestResult<WebhookTriggerUpdateBackgroundImageUrlResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<WebhookTriggerUpdateBackgroundImageUrlResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Webhook/background-img-url',
    ...options,
  });

export const webhookTriggerUpdateSummerPass = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookTriggerUpdateSummerPassData, ThrowOnError>,
): RequestResult<WebhookTriggerUpdateSummerPassResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<WebhookTriggerUpdateSummerPassResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Webhook/summerpass',
    ...options,
  });

export const webhookTriggerUpdateExternalOperator = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookTriggerUpdateExternalOperatorData, ThrowOnError>,
): RequestResult<WebhookTriggerUpdateExternalOperatorResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<WebhookTriggerUpdateExternalOperatorResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/rest/Webhook/external-operator',
    ...options,
  });
